import { useQuery } from '@tanstack/vue-query'
import { queries } from '../../keys'
import { DEFAULT_CACHE_TIME } from '../../constants'
import type { SuccessResponse } from '../../types/response'

export enum PROPERTIES_DICTIONARY_KEYS {
  BUILDING_STATUSES = 'building_status',
  LOCATIONS = 'location',
  ROOMS_COUNT = 'rooms_count',
  SALE_STATUSES = 'sale_status',
  TYPES = 'property_type',
  AMENITIES = 'property_amenity',
  DEVELOPER_NAMES = 'developer_names',
  EMIRATE_NAMES = 'emirate_names',
  CURRENCIES = 'currency',
  APARTMENT_TYPE = 'apartment_type',
}

export enum EXTERNAL_DICTIONARY_KEYS {
  FINANCE_PROJECTS = 'finance_projects',
}

export type Dictionary = {
  id: number
  name: string | null
  code: string
}

export const usePCDictionary = (entity: PROPERTIES_DICTIONARY_KEYS) => {
  const { fetch } = useAPIPCFetch()

  return useQuery({
    ...queries.dictionaries.entity(entity),
    queryFn: async () => {
      const response = await fetch<SuccessResponse<Dictionary[]>>({
        method: 'GET',
        url: `dictionary/${entity}`,
      })
      
      return response
    },
    select: data => data.data,
    staleTime: DEFAULT_CACHE_TIME,
    retry: false,
  })
}
